export const SurveyQuestionTypes = {
	SINGLE_CHOICE: 'single_choice',
	MULTI_CHOICE: 'multi_choice',
	TEXT: 'text',
	NUMBER: 'numeric',
};